import React from 'react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { formatDate, getStatusClass } from '../../lib/utils';
import { Plus, FileDown, Award } from 'lucide-react';

export default function AdminOrganizations({ 
  organizations, 
  onCreateOrg, 
  onEditOrg, 
  onToggleFoundingMember,
  onExportCSV 
}) {
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-semibold" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          Organizations
        </h2>
        <div className="flex gap-2">
          <Button variant="outline" onClick={onExportCSV} className="rounded-none" data-testid="export-registry-btn">
            <FileDown className="w-4 h-4 mr-2" />
            Export Registry CSV
          </Button>
          <Button onClick={onCreateOrg} className="btn-primary rounded-none" data-testid="create-org-btn">
            <Plus className="w-4 h-4 mr-2" />
            Create Organization
          </Button>
        </div>
      </div>
      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Display Name</th>
              <th>Legal Name</th>
              <th>Email</th>
              <th>Founding</th>
              <th>Status</th>
              <th>Created</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {organizations.map(org => (
              <tr key={org.id}>
                <td className="font-medium">{org.display_name}</td>
                <td>{org.legal_name}</td>
                <td>{org.contact_email}</td>
                <td>
                  <Button 
                    variant="ghost" 
                    size="sm" 
                    onClick={() => onToggleFoundingMember(org.id, org.founding_member)}
                    className={org.founding_member ? 'text-amber-600' : 'text-zinc-400'}
                    data-testid={`toggle-founding-${org.id}`}
                  >
                    <Award className="w-4 h-4" />
                  </Button>
                </td>
                <td>
                  <Badge variant="outline" className={`rounded-none ${getStatusClass(org.status)}`}>
                    {org.status}
                  </Badge>
                </td>
                <td>{formatDate(org.created_at)}</td>
                <td>
                  <Button variant="ghost" size="sm" onClick={() => onEditOrg(org)} data-testid={`edit-org-${org.id}`}>
                    Edit
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
